import { Alert } from '@mui/material';
import React from 'react';

const DevWarning: React.FC = () => {
	return (
		<Alert severity="warning" sx={{ width: '100%', alignSelf: 'center', fontWeight: 'bold' }} variant="outlined">
			This is currently under development and will be implemented in a future release
		</Alert>
	);
};

export default DevWarning;
